module.exports = __webpack_public_path__ + "img/Halloween.4c5659a.jpg";